import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-benefits-flash-office-card',
  templateUrl: './benefits-flash-office-card.component.html',
  styleUrls: ['./benefits-flash-office-card.component.scss']
})
export class BenefitsFlashOfficeCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
